import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("vaiyra_cart_v2") || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("vaiyra_cart_v2", JSON.stringify(items));
  }, [items]);

  const add = (product, size, qty = 1) => {
    setItems((prev) => {
      const key = `${product.id}__${size}`;
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => (i.key === key ? { ...i, qty: i.qty + qty } : i));
      }
      return [
        ...prev,
        {
          key,
          id: product.id,
          name: product.name,
          price: product.price,
          image: product.images[0],
          category_label: product.category_label,
          size,
          qty,
        },
      ];
    });
    setOpen(true);
  };

  const remove = (key) => {
    setItems((prev) => {
      const next = prev.filter((i) => i.key !== key);
      if (next.length === 0) setOpen(false);
      return next;
    });
  };

  const setQty = (key, qty) => {
    if (qty < 1) return remove(key);
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, qty } : i)));
  };

  const clear = () => setItems([]);

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.qty, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);

  return (
    <CartContext.Provider
      value={{ items, add, remove, setQty, clear, subtotal, count, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};
